/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart  Stock',
  'sidebar.parametrizacion': 'Parameterization',
  'sidebar.bodegasTiposPropiedades': 'Bodegas  Tipos  Propiedades',
  'bodegasTiposPropiedades.agregarBodegas Tipos Propiedades': 'Create Bodegas  Tipos  Propiedades',
  'bodegasTiposPropiedades.modificarBodegas Tipos Propiedades': 'Edit Bodegas  Tipos  Propiedades',
  'bodegasTiposPropiedades.eliminarBodegas Tipos Propiedades': 'Delete Bodegas  Tipos  Propiedades',
  'bodegasTiposPropiedades.bodegaTipoPropiedadId': 'Bodega   Tipo   Propiedad   Id ',
  'bodegasTiposPropiedades.bodegaTipoPropiedadDescripcion': 'Description',
  'bodegasTiposPropiedades.bodegas Tipos Propiedades': 'Bodegas Tipos Propiedades',
  'bodegasTiposPropiedades.verBodegas Tipos Propiedades': 'View Bodegas  Tipos  Propiedades',
  'bodegasTiposPropiedades.propiedad': 'Property',
};
